import { useEffect, useState } from 'react'
import Logo from '../ui/Logo'
import { useAuth } from '../auth/AuthContext'
import { supabase } from '../lib/supabase'

/** Écran provisoire (sous-étape 1) : prouve que la connexion et la lecture de la base fonctionnent.
 *  Il sera remplacé par le cadre commun (menu, chemin en pastilles) à la sous-étape 2. */
export default function Accueil() {
  const { appUser, signOut } = useAuth()
  const [familles, setFamilles] = useState<string[] | null>(null)
  const [erreur, setErreur] = useState<string | null>(null)

  useEffect(() => {
    supabase
      .from('product_families')
      .select('label')
      .eq('is_active', true)
      .order('sort_order')
      .then(({ data, error }) => {
        if (error) setErreur(error.message)
        else setFamilles(data.map((f) => f.label))
      })
  }, [])

  return (
    <div className="min-h-screen bg-[#F6F6F7] flex items-center justify-center px-4 font-baloo text-kdp-dark">
      <div className="w-full max-w-md bg-white border border-[#E7E7E7] rounded-2xl p-6">
        <Logo className="w-20 text-kdp-red mb-3" />
        <h1 className="text-xl font-bold">Bonjour {appUser?.full_name}</h1>
        <p className="text-[#6B6B6B] mb-4">La connexion à Supabase fonctionne.</p>
        <p className="font-semibold mb-1">Test de lecture : familles de produit</p>
        {erreur && <p className="text-kdp-red text-sm">Erreur : {erreur}</p>}
        {!erreur && !familles && <p className="text-sm text-[#6B6B6B]">Lecture…</p>}
        {familles && (
          <ul className="text-sm list-disc pl-5 mb-4">{familles.map((f) => <li key={f}>{f}</li>)}</ul>
        )}
        <button onClick={signOut} className="border border-[#E7E7E7] rounded-xl px-4 py-2 font-semibold">Se déconnecter</button>
      </div>
    </div>
  )
}
